import { useInterval } from "@/hooks/use-interval";
import {
  STATUS_POLL_INTERVAL_IN_MS,
  useBankIdActions,
  useBankIdStore,
} from "@/stores/bank-id/bank-id-store";
import type { BankIdStore } from "@/stores/bank-id/bank-id-store.types";

export function RefreshStatus() {
  const { handleCollectAuthenticationOrderStatus } = useBankIdActions();

  const orderRef = useBankIdStore((state: BankIdStore) => state.orderRef);
  const decrementSecondsLeft = useBankIdStore(
    (state: BankIdStore) => state.decrementSecondsLeft
  );

  useInterval(
    async () => {
      if (orderRef) {
        try {
          await handleCollectAuthenticationOrderStatus();
        } catch (_error) {
          console.log("refresh error");
          console.log(_error);
          //
        }
      }

      decrementSecondsLeft();
    },
    orderRef ? STATUS_POLL_INTERVAL_IN_MS : null
  );

  return null;
}
